<script lang="ts">
  import { onMount } from 'svelte';
  import MiniDemo from './MiniDemo.svelte';

  let demoVisible = $state(false);

  onMount(() => {
    // Fade in demo after a short delay
    setTimeout(() => {
      demoVisible = true;
    }, 300);
  });
</script>

<section class="hero">
  <div class="container">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          Privacy-First Budgeting.<br />
          Professional Analytics.<br />
          <span class="highlight">Zero Subscriptions.</span>
        </h1>
        <p class="hero-subtitle">
          Review your finances on your schedule without paying $15/month.
        </p>
        <div class="hero-features">
          <div class="feature-badge">
            <span class="badge-icon">✓</span>
            <span>No Accounts</span>
          </div>
          <div class="feature-badge">
            <span class="badge-icon">✓</span>
            <span>No Cloud</span>
          </div>
          <div class="feature-badge">
            <span class="badge-icon">✓</span>
            <span>No Subscriptions</span>
          </div>
        </div>
        <div class="cta-buttons">
          <a href="/app" class="btn btn-primary btn-large">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
            <span>Review Your Finances Free</span>
          </a>
        </div>
        <p class="platform-note">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
          Works in Any Browser • Install as PWA for Offline Access • Free Forever
        </p>
      </div>
      <div class="hero-demo" class:visible={demoVisible}>
        <MiniDemo />
      </div>
    </div>
  </div>
</section>

<style>
  .hero {
    /* Padding and background controlled by parent Landing.svelte */
    position: relative;
    overflow: hidden;
  }

  .hero::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 1000px;
    height: 1000px;
    background: radial-gradient(circle, rgba(16, 185, 129, 0.12) 0%, transparent 70%);
    transform: translateX(-50%);
    pointer-events: none;
  }

  .hero-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-3xl);
    align-items: center;
    position: relative;
    z-index: 1;
  }

  .hero-title {
    font-size: var(--font-size-5xl);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-tight);
    margin-bottom: var(--spacing-lg);
  }

  .highlight {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .hero-subtitle {
    font-size: var(--font-size-lg);
    color: var(--color-text-secondary);
    line-height: var(--line-height-normal);
    margin-bottom: var(--spacing-xl);
  }

  .hero-features {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-sm);
    margin-bottom: var(--spacing-xl);
  }

  .feature-badge {
    display: inline-flex;
    align-items: center;
    gap: var(--spacing-xs);
    padding: var(--spacing-xs) var(--spacing-md);
    background: var(--color-background);
    border: 1.5px solid var(--color-border);
    border-radius: var(--radius-full);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    color: var(--color-text-secondary);
    transition: all var(--transition-fast);
  }

  .feature-badge {
    border-color: #10b981;
  }

  .feature-badge:hover {
    background: linear-gradient(135deg, #d1fae5 0%, var(--color-background) 100%);
    transform: translateY(-2px);
  }

  .badge-icon {
    font-size: var(--font-size-base);
  }

  .cta-buttons {
    display: flex;
    gap: var(--spacing-md);
    flex-wrap: wrap;
    margin-bottom: var(--spacing-sm);
  }

  .platform-note {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    font-size: var(--font-size-xs);
    color: var(--color-text-muted);
    margin: 0;
  }

  .platform-note svg {
    flex-shrink: 0;
    opacity: 0.7;
  }

  .hero-demo {
    opacity: 0;
    transform: translateY(20px);
    transition: all var(--transition-slow);
  }

  .hero-demo.visible {
    opacity: 1;
    transform: translateY(0);
  }

  @media (max-width: 968px) {
    /* Padding controlled by parent Landing.svelte */

    .hero-content {
      grid-template-columns: 1fr;
      gap: var(--spacing-2xl);
    }

    .hero-title {
      font-size: var(--font-size-3xl);
    }

    .hero-subtitle {
      font-size: var(--font-size-base);
    }

    .cta-buttons {
      flex-direction: column;
    }

    .cta-buttons .btn {
      width: 100%;
    }
  }
</style>
